/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { jsx as _jsx } from "react/jsx-runtime";
const SvgStatus = (props) => (_jsx("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "ndl-icon-svg" }, props, { children: _jsx("path", { d: "M2 11.666H5.11125C5.37454 11.6661 5.63197 11.5882 5.85107 11.4421C6.07017 11.296 6.24113 11.0882 6.34242 10.8451L8.65363 5.40614C8.70642 5.28187 8.79565 5.17656 8.90954 5.10412C9.02343 5.03168 9.15661 4.99553 9.29147 5.00044C9.42634 5.00536 9.55654 5.05111 9.66486 5.13165C9.77318 5.21219 9.85452 5.32372 9.89813 5.45151L14.1063 18.5485C14.1499 18.6763 14.2313 18.7878 14.3396 18.8684C14.4479 18.9489 14.5781 18.9946 14.713 18.9996C14.8478 19.0045 14.981 18.9683 15.0949 18.8959C15.2088 18.8234 15.298 18.7181 15.3508 18.5939L17.6576 12.487C17.7589 12.2438 17.9298 12.0361 18.1489 11.89C18.368 11.7439 18.6255 11.6659 18.8888 11.666H22", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) })));
export default SvgStatus;
//# sourceMappingURL=Status.js.map